<template>
  <virtual-list class="list-infinite scroll-touch"
                :data-key="dataKey"
                :data-sources="getSources()"
                :data-component="getWrapper()"
                :estimated-size="estimated"
                :page-mode="true"
                ref="vsl">
  </virtual-list>
</template>

<script>
import virtualList from 'vue-virtual-scroll-list';
import PrizeUserWrapper from './PrizeUserWrapper';

export default {
  name: 'virtual-scroll-list',
  props: {
    items: {
      type: Array,
      required: true,
    },
    dataKey: {
      type: String,
      required: true,
    },
    estimated: {
      type: Number,
    },
    wrapperType: {
      type: String,
      required: true,
    },
    remain: {
      type: Number,
      default: 5,
    },
  },
  data() {
    return {
      page: 0,
      finished: false,
      onBottom: false,
      wrapperTypes: {
        PRIZE_USER: 'prize_user',
      },
    };
  },
  components: {
    VirtualList: virtualList,
  },
  methods: {
    getWrapper() {
      return PrizeUserWrapper;
    },
    getSources() {
      return this.items
        .filter((user, index) => index <= (this.page * this.remain) + this.remain);
    },
    setVirtualListToIndex(index) {
      if (this.$refs.vsl) {
        this.$refs.vsl.scrollToIndex(index);
      }
    },
    setVirtualListToOffset(offset) {
      if (this.$refs.vsl) {
        this.$refs.vsl.scrollToOffset(offset);
      }
    },
    setVirtualListToBottom() {
      if (this.$refs.vsl) {
        this.$refs.vsl.scrollToBottom();
      }
    },
    checkOverFlow() {
      const vsl = this.$refs.vsl;
      if (vsl) {
        this.overflow = vsl.getScrollSize() > vsl.getClientSize();
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/sharedcomponents/VirtualScrollList.vue